const isLocalDevelopment = ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);

// Configuration utility to ensure environment variables are always available
export const config = {
  // Production tiles live on the same static CDN as the app. Keeping the
  // development override preserves the standalone tile server workflow.
  TILES_URL: isLocalDevelopment
    ? (process.env.REACT_APP_TILES_URL || 'http://localhost:8080')
    : window.location.origin,
  API_URL: process.env.REACT_APP_API_URL || (isLocalDevelopment ? 'http://localhost:3001' : 'https://zoningpal-api.onrender.com'),
  // FIXED: SUPABASE_URL should ALWAYS point to direct Supabase instance, not to custom API domain
  SUPABASE_URL: process.env.REACT_APP_SUPABASE_URL || 'https://lkzqcyoxqzllldhgstiy.supabase.co',
  SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY || '',
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
};

// Debug function to log current config
export const logConfig = () => {
  const isDebug = process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG === 'true';
  if (!isDebug) return;
  // eslint-disable-next-line no-console
  console.log('🔧 Current config:', {
    TILES_URL: config.TILES_URL,
    API_URL: config.API_URL,
    SUPABASE_URL: config.SUPABASE_URL,
    HAS_GOOGLE_MAPS_KEY: !!config.GOOGLE_MAPS_API_KEY,
  });
};
